export default {
  data() {
    return {
      valid: {
        plan_name: {
          en: false,
          el: false,
        },
        plan_description: {
          en: false,
          el: false,
        },
        plan_price: false,
        reward_points: false,
        reward_type: false,
        payment_methods: false,
        interval_count: true,
        credit_initial_top_up: true,
        credit_threshold: true,
        credit_top_up: true,
        kind: {},
        double: {},
        integer: {},
      },
      success: {
        system_subscription_plan_type: false,
        plan_name: false,
        plan_description: false,
        plan_price: false,
        reward_points: false,
        kind: {},
        double: {},
        integer: {},
        reward_type: false,
        payment_methods: false,
        interval_count: false,
        credit_initial_top_up: false,
        credit_threshold: false,
        credit_top_up: false,
      },
      error: {
        system_subscription_plan_type: '',
        plan_name: '',
        plan_description: '',
        plan_price: '',
        reward_points: '',
        reward_type: '',
        payment_methods: '',
        interval_count: '',
        credit_initial_top_up: '',
        credit_threshold: '',
        credit_top_up: '',
        kind: {},
        double: {},
        integer: {},
      },
      errorMessages: {
        systemSubscriptionPlanTypeRequired: {
          el: 'Το πεδίο Τύπος Συνδρομητικού Πλάνου είναι υποχρεωτικό',
          en: 'System Subscription Plan Type is required',
          it: 'Il tipo di piano di abbonamento di sistema è obbligatorio',
        },
        planNameRequired: {
          el: 'Το πεδίο Όνομα Πλάνου είναι υποχρεωτικό',
          en: 'Plan Name is required',
          it: 'Il nome del piano è obbligatorio',
        },
        planDescriptionRequired: {
          el: 'Το πεδίο Περιγραφή Πλάνου είναι υποχρεωτικό',
          en: 'Plan Description is required',
          it: 'La descrizione del piano è obbligatoria',
        },
        planPriceRequired: {
          el: 'Το πεδίο Τιμή Πλάνου είναι υποχρεωτικό',
          en: 'Plan Price is required',
          it: 'Il prezzo del piano è obbligatorio',
        },
        planPriceMinError: {
          el: 'Η ελάχιστη τιμή πλάνου μπορεί να είναι 0',
          en: 'Minimum plan price can be 0',
          it: 'Il prezzo minimo del piano può essere 0',
        },
        reward_pointsRequired: {
          el: 'Το πεδίο Πόντοι Επιβράβευσης είναι υποχρεωτικό',
          en: 'Reward Points is required',
          it: 'I punti premio sono obbligatori',
        },
        reward_cashbackRequired: {
          el: 'Το πεδίο Cashback Επιβράβευσης είναι υποχρεωτικό',
          en: 'Reward Cashback is required',
          it: 'Il cashback premio è obbligatorio',
        },
        rewardTypeRequired: {
          el: 'Το πεδίο Τύπος Επιβράβευσης είναι υποχρεωτικό',
          en: 'Reward Type is required',
          it: 'Il tipo di premio è obbligatorio',
        },
        paymentMethodsRequired: {
          el: 'Το πεδίο Τρόποι Πληρωμής είναι υποχρεωτικό',
          en: 'Payment Methods is required',
          it: 'I metodi di pagamento sono obbligatori',
        },
        intervalCountRequired: {
          el: 'Το πεδίο Πλήθος Διαστημάτων είναι υποχρεωτικό',
          en: 'Interval Count is required',
          it: 'Il numero di intervalli è obbligatorio',
        },
        kindRequidred: {
          el: 'Το πεδίο αυτο είναι υποχρεωτικό',
          en: 'This field is required',
          it: 'Questo campo è obbligatorio',
        },
        doubleRequired: {
          en: 'Must be a positive number',
          el: 'Πρέπει να είναι ένας θετικός αριθμός',
          it: 'Deve essere un numero positivo',
        },
        integerRequired: {
          en: 'Must be a positive integer',
          el: 'Πρέπει να είναι ένας θετικός ακέραιος',
          it: 'Deve essere un intero positivo',
        },
        thresholdPositive: {
          en: 'Threshold must be greater than 0.5',
          el: 'Το threshold πρέπει να είναι μεγαλύτερο από 0.5',
          it: 'La soglia deve essere maggiore di 0.5',
        },
        topUpPositive: {
          en: 'Top-up amount (CAP) must be greater than 0.5',
          el: 'Το ποσό top-up (CAP) πρέπει να είναι μεγαλύτερο από 0.5',
          it: "L'importo top-up (CAP) deve essere maggiore di 0.5",
        },
        initialTopUpPositive: {
          en: 'Top-up amount must be greater than 0.5',
          el: 'Το ποσό top-up πρέπει να είναι μεγαλύτερο από 0.5',
          it: "L'importo top-up deve essere maggiore di 0.5",
        },
        initialTopUpRequiredForThreshold: {
          en: 'Top-up amount is required when threshold is set',
          el: 'Το ποσό top-up είναι υποχρεωτικό όταν έχει οριστεί threshold',
          it: "L'importo top-up è obbligatorio quando è impostata una soglia",
        },
        thresholdMustBeLessOrEqualTopUp: {
          en: 'Threshold must be less than or equal to top-up amount',
          el: 'Το threshold πρέπει να είναι μικρότερο ή ίσο με το ποσό top-up',
          it: "La soglia deve essere minore o uguale all'importo top-up",
        },
        topUpMustBeGreaterOrEqualThreshold: {
          en: 'Top-up amount (CAP) must be greater than or equal to threshold',
          el: 'Το ποσό top-up (CAP) πρέπει να είναι μεγαλύτερο ή ίσο με το threshold',
          it: "L'importo top-up (CAP) deve essere maggiore o uguale alla soglia",
        },
        maxThreeDecimals: {
          en: 'Up to 3 decimal places allowed',
          el: 'Επιτρέπονται έως 3 δεκαδικά ψηφία',
          it: 'Sono consentiti fino a 3 decimali',
        },
      },
    };
  },

  computed: {
    formValid() {
      for (let validKey in this.valid) {
        let value = this.valid[validKey];
        if (value && typeof value === 'object') {
          for (let attributeTitle in value) {
            let attrValue = value[attributeTitle];
            if (attrValue && typeof attrValue === 'object') {
              for (let key in attrValue) {
                if (!attrValue[key]) return false;
              }
            } else {
              if (!attrValue) return false;
            }
          }
        } else {
          if (!value) return false;
        }
      }
      return true;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
  },

  methods: {
    validateSystemSubscriptionPlanType() {
      if (!this.subscriptionPlan.system_subscription_plan_type_id) {
        this.error.system_subscription_plan_type =
          this.errorMessages.systemSubscriptionPlanTypeRequired[this.lang];
      } else {
        this.error.system_subscription_plan_type = '';
      }
    },

    validatePlanName() {
      if (!this.subscriptionPlan.plan_name.el || !this.subscriptionPlan.plan_name.en) {
        this.error.plan_name = this.errorMessages.planNameRequired[this.lang];
      } else {
        this.error.plan_name = '';
      }
    },

    validatePlanDescription() {
      if (
        !this.subscriptionPlan.plan_description.el ||
        !this.subscriptionPlan.plan_description.en
      ) {
        this.error.plan_description = this.errorMessages.planDescriptionRequired[this.lang];
      } else {
        this.error.plan_description = '';
      }
    },

    validatePlanPrice() {
      if (!this.subscriptionPlan.plan_price) {
        this.error.plan_price = this.errorMessages.planPriceRequired[this.lang];
      } else if (Number(this.subscriptionPlan.plan_price) < 0) {
        this.error.plan_price = this.errorMessages.planPriceMinError[this.lang];
      } else {
        this.error.plan_price = '';
      }
    },

    validateRewardPoints() {
      if (!this.subscriptionPlan.reward_points) {
        this.error.reward_points =
          this.errorMessages[`reward_${this.storeMode}Required`][this.lang];
      } else {
        this.error.reward_points = '';
      }
    },

    validateRewardType() {
      if (!this.subscriptionPlan.reward_type_id) {
        this.error.reward_type = this.errorMessages.rewardTypeRequired[this.lang];
      } else {
        this.error.reward_type = '';
      }
    },

    validatePaymentMethods() {
      const checkedAttribute = Object.values(this.checkedAttributes).find((attr) => attr);
      if (this.subscriptionPlan.plan_price === '0' && !checkedAttribute) {
        this.error.payment_methods = '';
      } else {
        if (this.subscriptionPlan.store_payment_methods.length == 0) {
          this.error.payment_methods = this.errorMessages.paymentMethodsRequired[this.lang];
        } else {
          this.error.payment_methods = '';
        }
      }
    },

    validateIntervalCount() {
      if (this.subscriptionPlan.interval && !this.subscriptionPlan.interval_count) {
        this.error.interval_count = this.errorMessages.intervalCountRequired[this.lang];
      } else {
        this.error.interval_count = '';
      }
    },

    parseNumeric(value) {
      if (!value) return null;
      return parseFloat(value.toString().replace(',', '.'));
    },

    validateCreditThresholdFields() {
      const isCredit = !!this.subscriptionPlan?.is_credit;
      if (!isCredit) {
        this.error.credit_initial_top_up = '';
        this.error.credit_threshold = '';
        this.error.credit_top_up = '';
        this.valid.credit_initial_top_up = true;
        this.valid.credit_threshold = true;
        this.valid.credit_top_up = true;
        return;
      }

      const initialTopUpRaw = this.subscriptionPlan?.top_up_amount;
      const thresholdRaw = this.subscriptionPlan?.threshold;
      const topUpRaw = this.subscriptionPlan?.threshold_top_up_amount;
      const initialTopUp = this.parseNumeric(initialTopUpRaw);
      const threshold = this.parseNumeric(thresholdRaw);
      const topUp = this.parseNumeric(topUpRaw);

      const hasInitialTopUp = !!initialTopUpRaw || initialTopUp === 0;
      const hasThreshold = !!thresholdRaw || threshold === 0;
      const hasTopUp = !!topUpRaw || topUp === 0;

      this.error.credit_initial_top_up = '';
      this.error.credit_threshold = '';
      this.error.credit_top_up = '';
      this.valid.credit_initial_top_up = true;
      this.valid.credit_threshold = true;
      this.valid.credit_top_up = true;
      this.success.credit_initial_top_up = !!initialTopUpRaw;
      this.success.credit_threshold = !!thresholdRaw;
      this.success.credit_top_up = !!topUpRaw;

      if (hasInitialTopUp && (isNaN(initialTopUp) || initialTopUp <= 0.5)) {
        this.error.credit_initial_top_up = this.errorMessages.initialTopUpPositive[this.lang];
        this.valid.credit_initial_top_up = false;
        this.success.credit_initial_top_up = false;
      }

      if (hasThreshold && (isNaN(threshold) || threshold <= 0.5)) {
        this.error.credit_threshold = this.errorMessages.thresholdPositive[this.lang];
        this.valid.credit_threshold = false;
        this.success.credit_threshold = false;
      }

      if (hasThreshold && !hasInitialTopUp) {
        this.error.credit_initial_top_up =
          this.errorMessages.initialTopUpRequiredForThreshold[this.lang];
        this.valid.credit_initial_top_up = false;
        this.success.credit_initial_top_up = false;
      }

      if (hasTopUp && (isNaN(topUp) || topUp <= 0.5)) {
        this.error.credit_top_up = this.errorMessages.topUpPositive[this.lang];
        this.valid.credit_top_up = false;
        this.success.credit_top_up = false;
      }

      if (
        hasThreshold &&
        hasInitialTopUp &&
        !isNaN(threshold) &&
        threshold > 0 &&
        !isNaN(initialTopUp) &&
        initialTopUp > 0 &&
        threshold > initialTopUp
      ) {
        this.error.credit_threshold =
          this.errorMessages.thresholdMustBeLessOrEqualTopUp[this.lang] + ` (${initialTopUp})`;
        this.valid.credit_threshold = false;
        this.success.credit_threshold = false;
      }

      if (
        hasThreshold &&
        hasTopUp &&
        !isNaN(threshold) &&
        threshold > 0 &&
        !isNaN(topUp) &&
        topUp > 0 &&
        topUp < threshold
      ) {
        this.error.credit_top_up =
          this.errorMessages.topUpMustBeGreaterOrEqualThreshold[this.lang] + ` (${threshold})`;
        this.valid.credit_top_up = false;
        this.success.credit_top_up = false;
      }
    },

    validateOption(attribute, optionKey) {
      if (!this.valid[optionKey]) this.$set(this.valid, optionKey, {});
      if (!this.success[optionKey]) this.$set(this.success, optionKey, {});
      if (!this.error[optionKey]) this.$set(this.error, optionKey, {});

      if (!this.valid[optionKey][attribute.title])
        this.$set(this.valid[optionKey], attribute.title, {});
      if (!this.success[optionKey][attribute.title])
        this.$set(this.success[optionKey], attribute.title, {});
      if (!this.error[optionKey][attribute.title])
        this.$set(this.error[optionKey], attribute.title, {});

      let keys = Array.isArray(attribute.options[optionKey])
        ? attribute.options[optionKey]
        : [attribute.options[optionKey]];

      if (!this.subscriptionPlanAttrs?.[attribute.title]) {
        keys.forEach((key) => {
          this.$set(this.valid[optionKey][attribute.title], key, true);
          this.$set(this.success[optionKey][attribute.title], key, true);
          this.$set(this.error[optionKey][attribute.title], key, '');
        });
        return;
      }

      keys.forEach((key) => {
        const optionValue = this.subscriptionPlanAttrs[attribute.title]?.[key];

        if (optionKey !== 'kind' && optionKey !== 'boolean' && !optionValue) {
          this.$set(
            this.error[optionKey][attribute.title],
            key,
            this.errorMessages[`${optionKey}Required`][this.lang]
          );
          this.$set(this.valid[optionKey][attribute.title], key, false);
          this.$set(this.success[optionKey][attribute.title], key, false);
          return;
        }

        if (optionKey === 'boolean') {
          this.$set(this.error[optionKey][attribute.title], key, '');
          this.$set(this.valid[optionKey][attribute.title], key, true);
          this.$set(this.success[optionKey][attribute.title], key, true);
          return;
        }

        if (optionKey !== 'kind' && (isNaN(optionValue) || Number(optionValue) <= 0)) {
          this.$set(
            this.error[optionKey][attribute.title],
            key,
            this.errorMessages[`${optionKey}Required`][this.lang]
          );
          this.$set(this.valid[optionKey][attribute.title], key, false);
          this.$set(this.success[optionKey][attribute.title], key, false);
          return;
        }

        const threeDecimalAttrs = ['sms', 'viber', 'mail'];
        const attrTitle = (attribute.title || '').toString().toLowerCase();
        if (
          threeDecimalAttrs.includes(attrTitle) &&
          optionValue !== null &&
          optionValue !== undefined
        ) {
          const strOpt = optionValue.toString().trim();
          const normalized = strOpt.replace(',', '.');
          const parts = normalized.split('.');
          if (parts[1] && parts[1].length > 3) {
            this.$set(
              this.error[optionKey][attribute.title],
              key,
              this.errorMessages.maxThreeDecimals[this.lang]
            );
            this.$set(this.valid[optionKey][attribute.title], key, false);
            this.$set(this.success[optionKey][attribute.title], key, false);
            return;
          }
        }

        this.$set(this.error[optionKey][attribute.title], key, '');
        this.$set(this.valid[optionKey][attribute.title], key, true);
        this.$set(this.success[optionKey][attribute.title], key, true);
      });
    },
  },

  watch: {
    ['subscriptionPlan.system_subscription_plan_type_id']: {
      immediate: true,
      handler(val) {
        // this.valid.system_subscription_plan_type = !!val;
        this.success.system_subscription_plan_type = !!val;
      },
    },

    ['subscriptionPlan.plan_name.en']: {
      immediate: true,
      handler(val) {
        this.valid.plan_name.en = !!val;
        this.success.plan_name = !!val;
      },
    },

    ['subscriptionPlan.plan_name.el']: {
      immediate: true,
      handler(val) {
        this.valid.plan_name.el = !!val;
        this.success.plan_name = !!val;
      },
    },

    ['subscriptionPlan.plan_description.en']: {
      immediate: true,
      handler(val) {
        this.valid.plan_description.el = !!val;
        this.success.plan_description = !!val;
      },
    },

    ['subscriptionPlan.plan_description.el']: {
      immediate: true,
      handler(val) {
        this.valid.plan_description.en = !!val;
        this.success.plan_description = !!val;
      },
    },

    ['subscriptionPlan.plan_price']: {
      immediate: true,
      handler(val) {
        this.valid.plan_price = !!val;
        this.success.plan_price = !!val;
      },
    },

    ['subscriptionPlan.reward_points']: {
      immediate: true,
      handler(val) {
        this.valid.reward_points = !!val;
        this.success.reward_points = !!val;
      },
    },

    ['subscriptionPlan.reward_type_id']: {
      immediate: true,
      handler(val) {
        this.valid.reward_type = !!val;
        this.success.reward_type = !!val;
      },
    },

    ['subscriptionPlan.store_payment_methods']: {
      immediate: true,
      handler(val) {
        this.valid.payment_methods = !!val?.length;
        this.success.payment_methods = !!val?.length;
      },
    },

    ['subscriptionPlan.interval_count']: {
      immediate: true,
      handler(val) {
        this.valid.interval_count = !!val;
        this.success.interval_count = !!val;
      },
    },

    ['subscriptionPlan.interval']: {
      immediate: true,
      handler(val) {
        if (val) {
          this.valid.interval_count = !!this.subscriptionPlan.interval_count;
          this.success.interval_count = !!this.subscriptionPlan.interval_count;
        } else {
          this.valid.interval_count = true;
          this.success.interval_count = true;
        }
      },
    },

    ['subscriptionPlan.is_credit']: {
      immediate: true,
      handler() {
        this.validateCreditThresholdFields();
      },
    },

    ['subscriptionPlan.threshold']: {
      immediate: true,
      handler() {
        this.validateCreditThresholdFields();
      },
    },

    ['subscriptionPlan.top_up_amount']: {
      immediate: true,
      handler() {
        this.validateCreditThresholdFields();
      },
    },

    ['subscriptionPlan.threshold_top_up_amount']: {
      immediate: true,
      handler() {
        this.validateCreditThresholdFields();
      },
    },

    ['subscriptionPlanAttrs']: {
      immediate: true,
      deep: true,
      handler(val) {
        let attributes = this.storeAttributes || this.companyAttributes || [];
        for (const attrTitle in val) {
          if (attrTitle && attributes?.length) {
            let attribute = attributes?.find((attr) => attr.title === attrTitle);
            for (const optionKey in attribute.options) {
              if (this.checkedAttributes[attrTitle]) {
                let keys = Array.isArray(attribute.options[optionKey])
                  ? attribute.options[optionKey]
                  : [attribute.options[optionKey]];
                keys.forEach((key) => {
                  let optionValue = val[attrTitle][key];
                  if (optionKey === 'kind') {
                    this.$set(this.valid[optionKey][attrTitle], key, !!optionValue);
                    this.$set(this.success[optionKey][attrTitle], key, !!optionValue);
                  } else if (optionKey === 'boolean') {
                    this.$set(this.valid[optionKey][attrTitle], key, true);
                    this.$set(this.success[optionKey][attrTitle], key, true);
                  } else {
                    this.$set(
                      this.valid[optionKey][attrTitle],
                      key,
                      !isNaN(optionValue) && Number(optionValue) > 0
                    );
                    this.$set(
                      this.success[optionKey][attrTitle],
                      key,
                      !isNaN(optionValue) && Number(optionValue) > 0
                    );
                  }
                });
              }
            }
          }
        }
      },
    },

    resetValidation: {
      immediate: true,
      handler(val) {
        if (val) {
          this.error = {
            system_subscription_plan_type: '',
            plan_name: '',
            plan_description: '',
            plan_price: '',
            reward_points: '',
            reward_type: '',
            payment_methods: '',
            interval_count: '',
            credit_initial_top_up: '',
            credit_threshold: '',
            credit_top_up: '',
            kind: {},
            double: {},
            integer: {},
          };

          this.setResetValidation(false);
        }
      },
    },
  },
};
